import { apiRequest } from '../config/apiRequest';
import API_ENDPOINTS from '../config/apiEndPoints';

export const fetchYears = async (setData, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.YEARS, 'GET');
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, years: response.data }));
        } else {
            throw new Error('Failed to fetch years');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchTrainingStatus = async (setData, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.TRAININGS_STATUS, 'GET');
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, trainingStatus: response.data }));
        } else {
            throw new Error('Failed to fetch trainingStatus');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchLevels = async (setData, setError, queryParams) => {

    try {
        const response = await apiRequest(`${API_ENDPOINTS.LEVELS}?client_id=${queryParams.client_id}`, 'GET');
        if (response.statusCode === 200) {
            const data = queryParams.level_id && queryParams.level_id !== null
                ? response.data.filter(item => item.value === queryParams.level_id)
                : response.data;

            setData(prev => ({ ...prev, levels: data }));
        } else {
            throw new Error('Failed to fetch levels');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchSoilTypes = async (setData, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.SOIL_TYPES, 'GET');
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, soilTypes: response.data }));
        } else {
            throw new Error('Failed to fetch soil Types');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchCropTypes = async (setData, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.CROP_TYPES, 'GET');
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, cropTypes: response.data }));
        } else {
            throw new Error('Failed to fetch crop Types');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchUserLevels = async (setData, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.USERLEVELS, 'GET');
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, userLevels: response.data }));
        } else {
            throw new Error('Failed to fetch user levels');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchEmployees = async (setData, setError, queryParams) => {

    try {
        const response = await apiRequest(API_ENDPOINTS.EMPLOYEES, 'GET', null, queryParams);
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, employees: response.data }));
            return response.data;
        } else {
            throw new Error('Failed to fetch employees');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchTrainingPlans = async (setData, setError, queryParams) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.GET_TRAINING_PLANS, 'GET', null, { client_id: queryParams.client_id });

        if (response.statusCode === 200) {
            const data = queryParams.level_id
                ? response.data.filter(item => item.level_id === queryParams.level_id)
                : response.data;

            setData(prev => ({ ...prev, trainingPlans: data }));
        } else {
            throw new Error('Failed to fetch training Plans');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchTrainingPlanLevelWiseReport = async (setData, setError, queryParams) => {
    let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();

    try {
        const response = await apiRequest(API_ENDPOINTS.GET_PLANREPORT_SUMMARY, 'GET', null, {
            client_id: queryParams.client_id,
            level_id: queryParams.level_id,
            ff_group_ids: params,
        });

        if (response.statusCode === 200) {
            // const data = queryParams.level_id
            //     ? response.data.filter(item => item.level_id === queryParams.level_id)
            //     : response.data;

            setData(prev => ({ ...prev, trainingPlanLevelReports: response.data }));
        } else {
            throw new Error('Failed to fetch training Plans');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};


export const fetchFarmers = async (setData, setError, queryParams) => {

    let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString()
    try {
        const response = await apiRequest(API_ENDPOINTS.FARMERS, 'GET', null, { ff_user_ids: params });
        if (response.statusCode === 200) {
            const data = queryParams.level_id
                ? response.data.filter(item => item.level_id === queryParams.level_id)
                : response.data;

            setData(prev => ({ ...prev, farmers: data }));
        } else {
            throw new Error('Failed to fetch farmers');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchTrainingSessions = async (setData, setError, queryParams) => {
    try {
        let params = queryParams.employees?.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();
        const response = await apiRequest(API_ENDPOINTS.TRAINING_SESSIONS, 'GET', null, { ff_user_ids: params, client_id: queryParams.client_id });
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, trainingSessions: response.data }));
        } else {
            throw new Error('Failed to fetch farmers');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchModulePages = async (setData, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.GET_MODULE_PAGES, 'GET',);
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, modulePages: response.data }));
        } else {
            throw new Error('Failed to fetch module Pages');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchVillageGroups = async (setData, setError, queryParams) => {
    try {
        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();
        const response = await apiRequest(API_ENDPOINTS.GET_VILLAGES_GROUPS, 'GET', null, { ff_user_ids: params });
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, villageGroups: response.data }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchSoilReports = async (setData, setError, queryParams) => {
    try {
        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString()

        const response = await apiRequest(API_ENDPOINTS.GET_SOIL_REPORTS, 'GET', null, { ff_user_ids: params }); if (response.statusCode === 200) {
            setData(prev => ({ ...prev, soilReports: response.data }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchFieldBook = async (setData, setError, queryParams) => {
    try {
        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString()
        const response = await apiRequest(API_ENDPOINTS.GET_fIELD_BOOK, 'GET', null, { ff_user_ids: params });
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, getFieldBooks: response.data }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchTrainingReport = async (setData, setError, queryParams) => {
    try {
        setData(prev => ({
            ...prev,
            subLoading: true
        }));

        const params = queryParams.employees
            .find((item) => item.level_id === 4)
            .data.map((item1) => item1.user_id);

        const [trainingSessionsResponse, trainingReportResponse] = await Promise.all([
            apiRequest(API_ENDPOINTS.GET_TRAINING_SESSIONS_REPORT, 'GET', null, { training_plan_id: queryParams.training_plan_id }),
            apiRequest(API_ENDPOINTS.GET_TRAINING_REPORT, 'GET', null, { training_plan_id: queryParams.training_plan_id })
        ]);

        if (trainingSessionsResponse.statusCode === 200 && trainingReportResponse.statusCode === 200) {
            const filteredTrainingSessions = trainingSessionsResponse.data
                ? trainingSessionsResponse.data.filter((item) => params.includes(parseInt(item.client_user_id)))
                : [];

            let filteredTrainingReport = trainingReportResponse.data
                ? trainingReportResponse.data.filter((item) => params.includes(parseInt(item.client_user_id)))
                : [];


            let filteredTrainingAttendance = filteredTrainingReport.reduce((acc, item) => {
                acc.present += parseInt(item.attended) || 0;
                acc.absent += parseInt(item.absent) || 0;
                acc.total += parseInt(item.attended) + parseInt(item.absent) || 0;
                acc.total_count += parseInt(item.total_count) || 0;
                acc.Not_Attended += parseInt(item.Not_Attended) || 0;
                return acc;
            }, { present: 0, absent: 0, total: 0, total_count: 0, Not_Attended: 0 });


            setData(prev => ({
                ...prev,
                trainingReport: [
                    { type: 'trainingSessions', data: filteredTrainingSessions },
                    { type: 'trainingReport', data: filteredTrainingReport },
                    { type: 'trainingAttendance', data: filteredTrainingAttendance },
                ]
            }));
        } else {
            setData(prev => ({
                ...prev,
                trainingReport: []
            }));
            throw new Error('Failed to fetch training data');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    } finally {
        setData(prev => ({
            ...prev,
            subLoading: false
        }));
    }
};

export const fetchIndividualFarmersDetails = async (setData, setError, queryParams) => {


    try {
        // setData(prev => ({
        //     ...prev,
        //     subLoading: true
        // }));
        const response = await apiRequest(API_ENDPOINTS.GET_INDIVIDUAL_FARMER_DETAILS, 'GET', null, { training_session_id: queryParams.training_session_id });
        if (response.statusCode === 200) {
            setData(prev => ({
                ...prev,
                individualFarmersDetails: response.data
            }));
        } else {
            throw new Error('Failed to fetch Data');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    } finally {
        setData(prev => ({
            ...prev,
            subLoading: false
        }));
    }
};


export const fetchSoilReportSummary = async (setData, setError, queryParams) => {

    try {
        setData(prev => ({
            ...prev,
            subLoading: true
        }));
        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();
        const response = await apiRequest(API_ENDPOINTS.GET_SOIL_REPORT_SUMMARY, 'GET', null, { year_id: queryParams.year_id });
        if (response.statusCode === 200) {

            const filteredUsersWiseData = response.data
                ? response.data.filter((item) => params.includes(parseInt(item.client_user_id)))
                : [];


            const filteredVillages = filteredUsersWiseData
                ? filteredUsersWiseData.filter((item) => item.level_id === 1)
                : [];
            const filteredBranches = filteredUsersWiseData
                ? filteredUsersWiseData.filter((item) => item.level_id === 2)
                : [];


            setData(prev => ({
                ...prev,
                soilReportSummary: [
                    { type: 'villages', data: filteredVillages },
                    { type: 'village-farmer', data: filteredVillages },
                    { type: 'groups', data: filteredBranches },
                ]
            }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    } finally {
        setData(prev => ({
            ...prev,
            subLoading: false
        }));
    }
};

export const fetchFieldBookSummary = async (setData, setError, queryParams) => {
    try {
        setData(prev => ({
            ...prev,
            subLoading: true
        }));
        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();
        const response = await apiRequest(API_ENDPOINTS.GET_FIELD_BOOK_SUMMARY, 'GET', null, { year_id: queryParams.year_id });
        if (response.statusCode === 200) {

            const filteredUsersWiseData = response.data
                ? response.data.filter((item) => params.includes(parseInt(item.client_user_id)))
                : [];

            const filteredVillages = filteredUsersWiseData
                ? filteredUsersWiseData.filter((item) => item.level_id === 1)
                : [];
            const filteredBranches = filteredUsersWiseData
                ? filteredUsersWiseData.filter((item) => item.level_id === 2)
                : [];


            setData(prev => ({
                ...prev,
                fieldBookSummary: [
                    { type: 'villages', data: filteredVillages },
                    { type: 'groups', data: filteredBranches },
                ]
            }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    } finally {
        setData(prev => ({
            ...prev,
            subLoading: false
        }));
    }
};

export const fetchAttendance = async (setData, setError, queryParams) => {


    try {
        setData(prev => ({
            ...prev,
            subLoading: true
        }));
        const response = await apiRequest(API_ENDPOINTS.ATTENDANCE, 'GET', null, { session_id: queryParams.training_session_id });
        if (response.statusCode === 200) {
            setData(prev => ({
                ...prev,
                sessionAttendance: response.data
            }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    } finally {
        setData(prev => ({
            ...prev,
            subLoading: false
        }));
    }
};

export const fetchAdOption = async (setData, setError, queryParams) => {
    try {
        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();
        const page = queryParams.page ?? 1;
        const limit = queryParams.limit ?? 10;
        const response = await apiRequest(API_ENDPOINTS.GET_ADOPTION, 'GET', null, { ff_user_ids: params, page, limit });
        if (response.statusCode === 200) {
            // API shape: { data: { pagination, records } }
            const records = Array.isArray(response.data)
                ? response.data
                : response.data?.records ?? [];
            const pagination = Array.isArray(response.data) ? null : response.data?.pagination ?? null;
            setData(prev => ({ ...prev, adOptionData: records, adOptionPagination: pagination }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};

export const fetchAdOptionSummary = async (setData, setError, queryParams) => {
    try {
        setData(prev => ({
            ...prev,
            subLoading: true
        }));

        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();
        const response = await apiRequest(API_ENDPOINTS.GET_ADOPTION_SUMMARY, 'GET', null, { target_year_id: queryParams.year_id });
        if (response.statusCode === 200) {

            const filteredUsersWiseData = response.data
                ? response.data.filter((item) => params.includes(parseInt(item.client_user_id)))
                : [];

            const filteredVillages = filteredUsersWiseData
                ? filteredUsersWiseData.filter((item) => item.level_id === 1)
                : [];
            const filteredBranches = filteredUsersWiseData
                ? filteredUsersWiseData.filter((item) => item.level_id === 2)
                : [];

            setData(prev => ({
                ...prev,
                adOptionSummaryReport: [
                    { type: 'villages', data: filteredVillages },
                    { type: 'groups', data: filteredBranches },
                ]
            }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    } finally {
        setData(prev => ({
            ...prev,
            subLoading: false
        }));
    }
};

export const fetchVillageGroupsAdOptionSummary = async (setData, setError, queryParams) => {
    try {
        setData(prev => ({
            ...prev,
            subLoading: true
        }));

        let params = queryParams.employees.find((item) => item.level_id === 4).data.map((item1) => item1.user_id).toString();
        const response = await apiRequest(API_ENDPOINTS.GET_VILLAGE_GROUP_ADOPTION_SUMMARY, 'GET', null, { target_year_id: queryParams.year_id, ff_user_ids: params });

        if (response.statusCode === 200) {
            setData(prev => ({
                ...prev,
                villageGroupAdoptionSummaryReport: response.data
            }));
        } else {
            throw new Error('Failed to fetch village groups');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    } finally {
        setData(prev => ({
            ...prev,
            subLoading: false
        }));
    }
};




export const fetchTrinigTypes = async (setData, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.GET_TRAINING_TYPES, 'GET');
        if (response.statusCode === 200) {
            setData(prev => ({ ...prev, trainingTypes: response.data }));
        } else {
            throw new Error('Failed to fetch years');
        }
    } catch (err) {
        console.error(err);
        setError(err.message);
    }
};